import { DropdownMenu } from '@ui-components/neo.tax';
import * as React from 'react';

import { useUpdateCompanyQuestion } from '@neo.tax/shared';

import { QuestionProps } from './company-info.types';

export const DropdownFieldNumber: React.FC<QuestionProps> = ({ question }) => {
  const updateCompanyQuestion = useUpdateCompanyQuestion(question.id, question.questionId);
  const options = Array.from({ length: 100 }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1),
  }));

  return (
    <DropdownMenu
      options={options}
      value={question.answerValue ?? null}
      onChange={(newValue: string): void => {
        updateCompanyQuestion({ answerValues: newValue });
      }}
    />
  );
};
